import styled from '@emotion/styled'
import { ReactNode } from 'react'

const Container = styled.div`
  margin: 0;
  max-width: 425px;
  overflow-x: hidden;
`

interface LayoutProps {
  children: ReactNode
}

const Layout = ({ children }: LayoutProps) => {
  return <Container>{children}</Container>
}

export default Layout
